var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.2,
    height: 17.2,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 0c4.744 0 8.6 3.856 8.6 8.6s-3.856 8.6-8.6 8.6S0 13.344 0 8.6 3.856 0 8.6 0Zm0 6.87a.801.801 0 0 0-.808.81v4.816l.006.102a.8.8 0 0 0 .802.706.801.801 0 0 0 .808-.808V7.679l-.006-.1A.81.81 0 0 0 8.6 6.87Zm.015-2.904c-.411-.031-.807.385-.823.834v.117l.007.106c.045.347.313.607.673.663l.128.01.105-.007a.848.848 0 0 0 .703-.797v-.16l-.007-.11c-.045-.36-.309-.607-.674-.649Z",
    fill: "#90A9C0",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.fdc93a532ecc2b7cca170969361b9c5b.svg";
export { ForwardRef as ReactComponent };